import { Select } from '~/components/select';
import ArrowDownFill from 'icon/arrow_triangle_down_fill.svg';
import Checkmark from 'icon/checkmark.svg';
import { Region, RegionDisplayMap } from '@lemon8/web-app-shared/i18n';
import { useAtomValue } from 'jotai';
import { $Locale } from '@lemon8/web-app-shared/atom';
import { FC, useCallback, useState } from 'react';
import cls from 'classnames';

import './style.scss';

const Regions: Region[] = [
  Region.jp,
  Region.th,
  Region.id,
  Region.vn,
  Region.my,
  Region.sg,
  Region.us,
  Region.au,
  Region.ca,
  Region.nz,
];

export const RegionSwitcher: FC<{ className: string }> = ({ className }) => {
  const { region } = useAtomValue($Locale);
  const [displayRegion, setDisplayRegion] = useState(region);
  const regionList = new Set<Region>([region, ...Regions]);

  const handleRegionSwitch = useCallback((value: Region) => {
    setDisplayRegion(value);
    const url = new URL(location.href);
    url.searchParams.set('region', value);
    location.href = url.toString();
  }, []);

  return (
    <div className={cls('region-switcher', `icon-${displayRegion}`, className)}>
      <Select
        value={displayRegion}
        showMask={false}
        arrowDownIcon={<ArrowDownFill className="arrow-icon" />}
        onChange={handleRegionSwitch}
      >
        {Array.from(regionList).map((r) => (
          <Select.Option key={r} value={r}>
            <i className={`icon-${r}`} />
            {RegionDisplayMap[r]}
            {displayRegion === r && <Checkmark className="ui-mobile-select-selected-icon checkmark" />}
          </Select.Option>
        ))}
      </Select>
    </div>
  );
};
